import React from "react";
import { Controller } from "react-hook-form";
import CreatableSelect from "react-select/creatable";

function Elements({
  fields,
  control,
  register,
  errors,
  watch,
  elementsData,
  append,
  remove,
  handleAttachmentFileChange,
  fileCounts,
  fileUrls,
  setValue,
  getValues,
  trigger,
}) {
  const handleChangeOfInputWithLengthCheck = (fieldName) => (e) => {
    const value = e.target.value;
    setValue(fieldName, value, { shouldValidate: true });
  };

  return (
    <>
      <div className="col-12">
        <hr className="mt-1" />

        <h5 className="mb-2">Elements</h5>

        <div className="row g-2">
          <div className="col">
            <label className="form-label">Name</label>
          </div>
          <div className="col">
            <label className="form-label">Value</label>
          </div>
          <div className="col">
            <label className="form-label">Effective Date</label>
          </div>
          <div className="col">
            <label className="form-label">End Date</label>
          </div>
          <div className="col-2">
            <label className="form-label">Description</label>
          </div>
          <div className="col">
            <label className="form-label">Attachment</label>
          </div>
          <div className="col-1">
            <label className="form-label">Action</label>
          </div>
        </div>
        {fields.map((field, index) => (
          <div className="row g-2 mb-1" key={field.id}>
            <div className="col">
              {/* <Controller
                name={`elements[${index}].name`}
                control={control}
                rules={{
                  validate: (value) => {
                    if (!value || value.value === 0) return true;
                    return true;
                  },
                }}
                render={({ field }) => (
                  <CreatableSelect
                    {...field}
                    options={elementsData.map((element) => ({
                      value: element.id,
                      label: element.name,
                    }))}
                    onChange={(selectedOption, actionMeta) => {
                      if (actionMeta.action === "create-option") {
                        setValue(`elements[${index}].name`, {
                          value: 0,
                          label: selectedOption.label,
                        });
                      } else if (actionMeta.action === "clear") {
                        setValue(`elements[${index}].name`, "");
                      } else {
                        setValue(
                          `elements[${index}].name`,
                          selectedOption || { value: 0, label: "" }
                        );
                      }
                      trigger(`elements[${index}].name`);
                    }}
                    className="react-select-style"
                    classNamePrefix="react-select-style-pref"
                    isClearable
                  />
                )}
              /> */}
              <Controller
                name={`elements[${index}].name`}
                control={control}
                rules={{
                  validate: (value) => value?.value !== undefined || true,
                }}
                render={({ field }) => (
                  <CreatableSelect
                    {...field}
                    value={field.value || null}
                    options={elementsData.map((element) => ({
                      value: element.id,
                      label: element.name,
                    }))}
                    onChange={(selectedOption, actionMeta) => {
                      if (actionMeta.action === "create-option") {
                        setValue(`elements[${index}].name`, {
                          value: 0,
                          label: selectedOption.label,
                        });
                      } else if (actionMeta.action === "clear") {
                        setValue(`elements[${index}].name`, null);
                      } else {
                        setValue(
                          `elements[${index}].name`,
                          selectedOption || null
                        );
                      }
                      trigger(`elements[${index}].name`);
                    }}
                    className="react-select-style"
                    classNamePrefix="react-select-style-pref"
                    isClearable
                  />
                )}
              />
              {errors.elements?.[index]?.name && (
                <small className="text-danger">
                  {errors.elements[index].name.message}
                </small>
              )}
            </div>

            <div className="col">
              <input
                {...register(`elements[${index}].elementDetail.value`, {
                  required: watch(`elements[${index}].name`)
                    ? "This field is required."
                    : false,
                })}
                type="text"
                className="form-control"
                placeholder=""
              />
              {errors.elements?.[index]?.elementDetail?.value && (
                <small className="text-danger">
                  {errors.elements[index].elementDetail.value.message}
                </small>
              )}
            </div>

            <div className="col">
              <input
                {...register(`elements[${index}].elementDetail.effectiveDate`, {
                  validate: {
                    lessThanEndDate: (value) => {
                      const endDate = getValues(
                        `elements[${index}].elementDetail.endDate`
                      );
                      return (
                        !value || // No validation if no value
                        !endDate ||
                        new Date(value) < new Date(endDate) ||
                        "Must be less than End Date."
                      );
                    },
                  },
                })}
                type="date"
                className="form-control"
                placeholder=""
              />
              {errors.elements?.[index]?.elementDetail?.effectiveDate && (
                <small className="text-danger">
                  {errors.elements[index].elementDetail.effectiveDate.message}
                </small>
              )}
            </div>

            <div className="col">
              <input
                {...register(`elements[${index}].elementDetail.endDate`, {
                  validate: {
                    greaterThanEffectiveDate: (value) => {
                      const effectiveDate = getValues(
                        `elements[${index}].elementDetail.effectiveDate`
                      );
                      // Validate only if end date is provided
                      return (
                        !value || // No validation if no value
                        !effectiveDate ||
                        new Date(value) > new Date(effectiveDate) ||
                        "Must be greater than Effective Date."
                      );
                    },
                  },
                })}
                type="date"
                className="form-control"
                placeholder=""
              />
              {errors.elements?.[index]?.elementDetail?.endDate && (
                <small className="text-danger">
                  {errors.elements[index].elementDetail.endDate.message}
                </small>
              )}
            </div>

            <div className="col-2">
              <input
                {...register(`elements[${index}].elementDetail.description`, {
                  maxLength: {
                    value: 250,
                    message: "Maximum of 250 characters allowed.",
                  },
                })}
                type="text"
                className="form-control"
                placeholder=""
                onChange={handleChangeOfInputWithLengthCheck(
                  `elements[${index}].elementDetail.description`
                )}
              />
              {errors.elements?.[index]?.elementDetail?.description && (
                <small className="text-danger">
                  {errors.elements[index].elementDetail.description.message}
                </small>
              )}
            </div>

            <div className="col">
              <div className="position-relative">
                <button
                  className="btn btn-outline-primary py-1 px-2 position-relative"
                  type="button"
                >
                  <span className="fas fa-cloud-arrow-up me-1"></span>
                  <span className="me-1">Upload File</span>
                  <input
                    type="file"
                    className="attachment"
                    onChange={(event) =>
                      handleAttachmentFileChange(event, index)
                    }
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      opacity: 0,
                      cursor: "pointer",
                    }}
                  />
                </button>

                {fileCounts[index] ? (
                  <a
                    href={fileUrls[index]}
                    title="Preview"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ms-2 text-secondary"
                  >
                    <i className="fa fa-paperclip"></i>
                  </a>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div className="col-1">
              <button
                className="btn btn-outline-primary py-1 px-2"
                type="button"
                onClick={() =>
                  append({
                    id: 0,
                    name: "",
                    description: "",
                    createdBy: localStorage.getItem("userId"),
                    elementDetail: {
                      value: "",
                      description: "",
                      effectiveDate: null,
                      endDate: null,
                      createdBy: localStorage.getItem("userId"),
                      fileName: "",
                      filePath: "",
                      base64String: "",
                    },
                  })
                }
              >
                <span className="fas fa-plus"></span>
              </button>
              {fields.length > 1 && (
                <button
                  className="btn btn-outline-danger py-1 px-2 ms-1"
                  type="button"
                  onClick={() => remove(index)}
                >
                  <span className="fas fa-minus"></span>
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default Elements;
